<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <div class="stripe-configuration">
          <h2>{{ editMode ? 'Edit' : 'Create' }} Session </h2>
          <form @submit.prevent="saveChanges">
            <div v-for="field in fields" :key="field.name" class="form-group">
              <label :for="field.name">{{ field.label }}:</label>
              <input :id="field.name" v-model="editedConfig[field.name]"
                     :style="{ minWidth: '500px', width: editedConfig[field.name] ? `${editedConfig[field.name].length * 10}px` : '100px' }"
                     type="text" class="form-control" :disabled="(field.name === 'sessionId' || field.name === 'channelId' || field.name === 'channelName')">
            </div>
            <div v-if="error != ''" class="error-message">{{error}}</div>
            <br>
            <a role="button" class="procricket-btn" @click="saveChanges">Save changes</a>
          </form>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Header from '@/components/Header.vue'
import {Session} from '@/model/models'
import AdminService from "@/services/admin-service";

export default defineComponent({
  name: 'SessionEdit',
  components: {
    Header,
  },
  data () {
    return {
      editedConfig: {
        sessionId : this.$route.params.sessionId,
        userId : this.$route.params.userId,
        edgeAddress : this.$route.params.edgeAddress,
        protocol : this.$route.params.protocol,
        channelId : this.$route.params.channelId,
        channelName : this.$route.params.channelName,
        vidictId : this.$route.params.vidictId,
        region : this.$route.params.region,
        deviceOs : this.$route.params.deviceOs,
        deviceType : this.$route.params.deviceType,
        userAgent: this.$route.params.userAgent,
        appVersion : this.$route.params.appVersion,
        randomUUID: this.$route.params.randomUUID,
        application: this.$route.params.application,
        startTime: this.$route.params.startTime,
        endTime: this.$route.params.endTime,
      },
      editMode: false,
      fields: [
        { name: "sessionId", label: "Session Id" },
        { name: "userId", label: "User Id" },
        { name: "region", label: "Region" },
        { name: "edgeAddress", label: "Edge Address" },
        { name: "protocol", label: "Protocol" },
        { name: "channelId", label: "Channel Id" },
        { name: "channelName", label: "Channel Name" },
        { name: "vidictId", label: "Vidict Id" },
        { name: "deviceOs", label: "Device Os" },
        { name: "deviceType", label: "Device Type" },
        { name: "appVersion", label: "App Version" },
        { name: "userAgent", label: "UserAgent" },
        { name: "randomUUID", label: "randomUUID" },
        { name: "application", label: "application" },
        { name: "startTime", label: "Start Time" },
        { name: "endTime", label: "End Time" },
      ],
      error: ""
    }
  },
  created() {
    if (this.$route.params.sessionId) {
      this.editMode = true;
    }
  },
  methods: {
    saveChanges() {
      const dataToSave = new Session(
          this.editedConfig.sessionId ,
          this.editedConfig.userId ,
          this.editedConfig.edgeAddress ,
          this.editedConfig.protocol ,
          this.editedConfig.channelId ,
          this.editedConfig.vidictId ,
          this.editedConfig.region ,
          this.editedConfig.deviceOs ,
          this.editedConfig.deviceType ,
          this.editedConfig.userAgent,
          this.editedConfig.appVersion,
          this.editedConfig.randomUUID,
          this.editedConfig.application,
          this.editedConfig.startTime,
          this.editedConfig.endTime,
      );

      if (this.editMode) {
        // Editing an existing configuration
        AdminService.updateSession(dataToSave).then(() => {
          alert('Insert complete');
          // Redirect to the /stripe page
          this.$router.push({ name: 'Sessions' });
        }).catch((error) => {
          console.error("Error updating Session:", error);
          if (error.response && error.response.data && error.response.data.message) {
            alert(error.response.data.message);
          }
        });
      }
    }
  }
})
</script>
<style src="../../assets/style.css">
</style>
